import { methods, ServiceMaker } from './index';

const { POST } = methods;

export const channelmaster = data => ServiceMaker(`v1/api/channelMasters`, POST, null, data);